import styled from "@emotion/styled";
import * as Checkbox from "@radix-ui/react-checkbox";
import { LIGHT_BACKGROUND, OLD_BLUE } from "src/constants/colors";

export const StatusListContainer = styled.div<{ show: boolean }>`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(220, 223, 228, 1);
  border-radius: 12px;
  box-shadow:
    0px 2px 8px rgba(0, 0, 0, 0.06),
    0px 16px 64px -12px rgba(0, 0, 0, 0.1);
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  padding: 6px;
  position: absolute;
  top: 60px;
  left: 0px;
  width: fit-content;
  z-index: 1;
`;

export const TitleLabel = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 12px;
  padding: 12px 8px 8px;
`;

export const StatusRow = styled.div<{
  onClick: () => void;
  role: "button";
  tabIndex: number;
}>`
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: flex-start;
  padding: 8px;
  border-radius: 8px;

  &:hover {
    background-color: ${LIGHT_BACKGROUND};
  }
`;

export const StyledCheckbox = styled(Checkbox.Root)`
  background-color: ${({ checked }) =>
    checked ? OLD_BLUE : "rgba(255,255,255, 1)"};
  border: 1.5px solid
    ${({ checked }) => (checked ? OLD_BLUE : "rgba(104, 112, 131, 1)")};
  border-radius: 4px;
  height: 16px;
  overflow: hidden;
  position: relative;
  width: 16px;
  cursor: pointer;

  &:hover {
    border-color: ${OLD_BLUE};
  }
`;

export const StyledCheckboxIndicator = styled(Checkbox.Indicator)`
  background-color: ${OLD_BLUE};
  color: rgba(255, 255, 255, 1);
  position: absolute;
  top: -3px;
  left: -2px;

  & > svg {
    transform: scale(0.6);
  }
`;
